import addBorderInHighContrastMode from '@/lib/styling/addBorderInHighContrastMode';
import addHighContrastStyles from '@/lib/styling/addHighContrastStyles';
import styled from '@emotion/styled';

const CommentWrapper = styled('li')(
  ({ theme }) => ({
    marginBottom: 12,
    padding: '16px 24px',
    backgroundColor: theme.palette.action.hover,
    borderRadius: 4,
  }),
  addBorderInHighContrastMode,
  addHighContrastStyles(({ theme }) => {
    if (theme.isDark) {
      return {
        backgroundColor: 'rgba(0, 0, 0, 0.2)',
      };
    }
  }),
);

export default CommentWrapper;
